export default "__VITE_ASSET__d7598575__"